import React from "react";

// Simple read-only popup used to display an editable content block (HTML)
// fetched from the database, e.g. the medical-condition disclaimer shown on
// the signup page. Styled to match the shared Modal component.
const ContentModal = ({ show, onClose, title, content }) => {
  if (!show) return null;

  return (
    <div
      id="contentModal"
      tabIndex="-1"
      aria-hidden="true"
      onClick={onClose}
      className="fixed flex justify-center bg-gray-900 bg-opacity-90 pt-[100px] z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full left-0 top-0"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative max-w-3xl max-h-full md:w-full width-80 md:mx-auto mr-auto"
      >
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700 p-2">
          <div className="flex items-start justify-between p-4 rounded-t dark:border-gray-600">
            <div className="text-xl text-black dark:text-white font-medium">
              {title}
            </div>
            <button
              onClick={onClose}
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="px-5 pb-6 space-y-4 max-h-[60vh] overflow-y-auto">
            <div
              className="text-base leading-relaxed text-black dark:text-gray-300 space-y-3"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentModal;
